import { Flex, Box } from "@chakra-ui/react";
import colors from "core/resources/theme/colors";
import { DiaConciliacao } from "features/conciliacao-bancaria/typings";
import { Tooltip, Row } from "antd";
import { getDiasMes } from "./../../../../../../../../../../../infra/helpers/getDiasMes";

interface ConciliacaoDiasProps {
  diasConciliacao: DiaConciliacao[];
  mes: string;
  selectedDia?: number | undefined;
  onClick?: (dia: number | undefined) => any;
}

export default function ConciliacaoDias({
  diasConciliacao,
  mes,
  selectedDia,
  onClick,
}: ConciliacaoDiasProps) {
  const diasMes = getDiasMes(mes);

  const _onClickDia = (dia: number) => {
    if (selectedDia && selectedDia === dia) {
      onClick?.(undefined);
    } else {
      onClick?.(dia);
    }
  };

  return (
    <Box as={Row} mb="50px" gutter={32} pl="16px" pr="13px" gap={"4px"}>
      {diasMes.map((dia) => {
        const dadosDia = diasConciliacao.find((d) => dia === d.numeroDia);
        const _conciliado =
          dadosDia?.conciliado && dadosDia?.totalContasSemExtrato === 0;

        return (
          <Tooltip
            placement="bottom"
            title={
              dadosDia?.fimDeSemana
                ? "Fim de Semana"
                : _conciliado
                ? "Conciliado"
                : dadosDia?.conciliado === false ||
                  !!dadosDia?.totalContasSemExtrato
                ? "Não conciliado"
                : "Sem lançamento"
            }
          >
            <Flex
              minW={"24px"}
              w={`calc(${100 / diasMes.length}% - 4px)`}
              h="32px"
              mb="6px"
              borderWidth={2}
              borderColor={selectedDia === dia ? colors.primary : "transparent"}
              align="center"
              alignItems="center"
              justifyContent="center"
              rounded="5px"
              cursor="pointer"
              onClick={() => _onClickDia(dia)}
              bg={
                dadosDia?.conciliado && dadosDia?.totalContasSemExtrato === 0
                  ? colors.accentPositive + "E6"
                  : dadosDia?.conciliado === false ||
                    !!dadosDia?.totalContasSemExtrato
                  ? colors.accentNegative + "CC"
                  : dadosDia?.fimDeSemana
                  ? colors.lightCyan
                  : colors.white
              }
              color={
                dadosDia?.conciliado ||
                dadosDia?.conciliado === false ||
                !!dadosDia?.totalContasSemExtrato
                  ? colors.white
                  : undefined
              }
              left="-75px"
              p={2}
            >
              {dia}
            </Flex>
          </Tooltip>
        );
      })}
    </Box>
  );
}
